import * as React from 'react';
import {change, Field, InjectedFormProps, reduxForm} from 'redux-form';
import {Button, ButtonGroup, Col} from 'reactstrap';
import Panel from '../../../../theme/components/Panel';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import renderMultiSelectField from '../../../../theme/components/form/MultiSelect';
import {error} from '../../../../utils/notification-actions';

interface AvanceAnualFormState {
    categorias: string[];
    lineas: string[];
}

class AvanceAnualForm extends React.PureComponent<InjectedFormProps & ReduxProps, AvanceAnualFormState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);
        this.state = {
            categorias: [],
            lineas: []
        };
    };

    public componentDidMount() {
        this.obtenerCategorias();
        this.obtenerLineas();
    }

    private obtenerCategorias = async () => {
        try {
            const response = await this.apiClient.obtenerAvanceAnualCategorias();
            this.setState({categorias: response});
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error al obtener categorias'));
        }
    };

    private obtenerLineas = async (categorias?: string[]) => {
        try {
            const response = await this.apiClient.filtrarAvanceAnualLineas(categorias);
            this.setState({lineas: response});
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error al obtener lineas'));
        }
    };

    private get categoriaOptions() {
        const categoriaList = this.state.categorias;
        const options = [] as any;

        categoriaList.forEach((cat) => {
            options.push({value: cat, label: cat});
        });
        return options;
    }

    private get lineaOptions() {
        const lineaList = this.state.lineas;
        const options = [] as any;
        lineaList.forEach((lin) => {
            options.push({value: lin, label: lin});
        });
        return options;
    }

    private handleCategoriaChange = (obj: any) => {
        this.props.dispatch(change('avance_anual_form', 'lineas', []));
        const categorias = [] as any;
        for (const key in obj) {
            if (obj.hasOwnProperty(key) && obj[key].value) {
                categorias.push(obj[key].value);
            }
        }
        this.obtenerLineas(categorias);
    };

    public render() {
        const {handleSubmit} = this.props;

        return (
            <Panel xs={12} md={12} divider={true} title='Filtros'>
                <form className='form' onSubmit={handleSubmit}>
                    <Col md={12}>
                        <div className='form__form-group'>
                            <label className='form__form-group-label'>Categorías </label>
                            <div className='form__form-group-field'>
                                <Field
                                    name='categorias'
                                    component={renderMultiSelectField}
                                    onChange={this.handleCategoriaChange}
                                    options={this.categoriaOptions}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={12}>
                        <div className='form__form-group'>
                            <label className='form__form-group-label'>Líneas </label>
                            <div className='form__form-group-field'>
                                <Field
                                    name='lineas'
                                    component={renderMultiSelectField}
                                    options={this.lineaOptions}
                                />
                            </div>
                        </div>
                    </Col>
                    <ButtonGroup className='btn-group--justified'>
                        <Button color='success' type='submit'>FILTRAR</Button>
                    </ButtonGroup>

                </form>
            </Panel>
        )
    }
}

export default reduxForm({
    form: 'avance_anual_form', // a unique identifier for this form
})(AvanceAnualForm);



// WEBPACK FOOTER //
// ./src/components/pages/avance/anual/avance-anual-form.tsx